import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'auth',
  initialState: {
    profile: null,
    terms: null
  },
  reducers: {
    //triggers handled by sagas/auth.js
    getTerms: () => { },
    register: () => { },
    resendOtp: () => { },
    verifyEmail: () => { },
    login: () => { },
    forgotPassword: () => { },
    resetPassword: () => { },
    changePassword: () => { },
    getProfile: () => { },
    updateProfile: () => { },
    logout: () => { },

    setProfile: (state, action) => {
      if (action.payload.profile !== undefined) state.profile = action.payload.profile;
      if (action.payload.terms !== undefined) state.terms = action.payload.terms;
    },
    clearProfile: (state) => {
      state.profile = null;
    }
  }
});

export const {
  getTerms, register, resendOtp, verifyEmail, login, forgotPassword, resetPassword,
  changePassword, getProfile, updateProfile, logout, setProfile, clearProfile
} = slice.actions;
export default slice.reducer;
